import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { RichText, Icon, Button } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './enginePromotionalCode.js';
import { CSSTransition } from 'react-transition-group';

class EnginePromotionalCode extends React.Component {
  static displayName = 'EnginePromotionalCode';

  render() {
    const { theme, content } = this.props;
    const { classes } = theme.styles;
    const { showModalView, promoVisible, promoCode, onChange, clearSearch, applyCode, modalBreak, engineMerged, dropDownPosition } = this.props.config;
    this.cx = theme.bind();

    const euroStartTheme = theme.theme === 'eurostarshotels' || theme.theme === 'eurostarshotelcompany' || theme.theme === 'portalDesign';
    return (
      <div className={[theme.computedInnerStyle, this.cx({ engineMerged: engineMerged })].join(' ')}>
        <div className={classes.promoContainer}>
            <div>
              <div className={[classes.dropDown,dropDownPosition === 'top' ? classes.dropDownTop : classes.dropDownBottom].join(' ')} id={'promoContainer'} tabIndex={-1}>
                <CSSTransition
                  in={!!promoVisible}
                  timeout={euroStartTheme ? 0 : 500}
                  mountOnEnter
                  unmountOnExit
                  classNames={{
                    enter: classes.dropDownEnter,
                    enterActive: classes.dropDownEnterActive,
                    exit: classes.dropDownLeave,
                    exitActive: classes.dropDownLeaveActive
                  }}>
                  <div className={classes.dropDownContainer}>
                    <div className={classes.animationContainer}>
                      <div className={classes.animationContent}>
                        {modalBreak && <Icon unicodeContent={'e06f'} innerStyle={classes.iconsEngine} />}
                        <input
                          onChange={onChange}
                          className={classes.inputPromo}
                          value={promoCode}
                          placeholder={content.t('_%insertar código promocional%_')}
                        />
                        {(showModalView && modalBreak && promoCode !== '') && (
                          <Button
                            onClick={clearSearch}
                            innerStyle={classes.closeButtonClose}
                            icon={{ unicodeContent: 'e001' }}
                          />
                        )}
                        <div className={classes.searchButtonContainer}>
                          <Button
                            disabled={promoCode === ''}
                            onClick={applyCode}
                            innerStyle={['toggleMainButton', classes.searchButton]}
                            richText={{
                              ucFirst: true,
                              text: '_%aplicar%_',
                              translate: true
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </CSSTransition>

              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default compose(
  PropertyManager(['showModalView', 'promoVisible', 'promoCode', 'onChange', 'clearSearch', 'applyCode', 'modalBreak','engineMerged','dropDownPosition']),
  withThemeJSS({ styleFile, link: true, index: 100 }),
  withContent('i18n')
)(EnginePromotionalCode);
